<template>
    <div>
        <!-- <div class="row" v-if="disputeMode">
            <div class="col-lg-12">
                <div class="alert alert-warning">
                    <strong>Modify Shift Details: </strong> Enter the corrected details below and click 'Save'.
                </div>
            </div>
        </div> -->

        <!--  v-if="over_24_hours" -->
        <b-alert variant="warning" show v-if="over_24_hours">
            The duration of this visit is more than 24 hours.  Please reduce the duration to be 24 hours or less to submit for invoicing.
        </b-alert>

        <!-- v-if="no_adls_set" -->
        <b-alert variant="danger" show v-if="!adls_set">
            There are no activities logged for this visits.  Please indicate the activities performed during the visit to submit for invoicing.
        </b-alert>

        <b-card :title="`Review Visit on ${formatDateFromUTC(shift.checked_in_time)}`">
            <b-row class="with-padding-bottom">
                <b-col sm="6">
                    <strong>Policy Holder</strong>
                    <br />
                    {{ client.name }}
                </b-col>
                <b-col sm="6" v-if="shift.caregiver">
                    <strong>Provider</strong><br />
                    {{ shift.caregiver.name }}
                </b-col>
            </b-row>
            <b-row class="with-padding-bottom" v-show="!disputeMode">
                <b-col sm="6">
                    <strong>Clocked In Time</strong><br />
                    {{ formatDateTimeFromUTC(form.checked_in_time) }}
                </b-col>
                <b-col sm="6">
                    <strong>Clocked Out Time</strong><br />
                    <span v-if="form.checked_out_time">{{ formatDateTimeFromUTC(form.checked_out_time) }}  ({{ numberFormat(duration) }} Hours)</span>
                    <span v-else>Pending</span>
                    <br />
                </b-col>
            </b-row>

            <!-- <b-row v-show="disputeMode">
                <b-col sm="6">
                    <b-form-group label="Checked In Date &amp; Time" label-for="checked_in_time">
                        <b-row>
                            <b-col cols="7">
                                <date-picker v-model="edit.checked_in_date" placeholder="Date (MM/DD/YYYY)"></date-picker>
                            </b-col>
                            <b-col cols="5">
                                <time-picker v-model="edit.checked_in_time" placeholder="Time (Ex. 12:00 PM)"></time-picker>
                            </b-col>
                        </b-row>
                        <input-help :form="form" field="checked_in_time" text=""></input-help>
                        <small class="form-text text-muted" v-if="show_12_hr_warning">
                          <span  class="text-warning">Warning this shift is at or exceeds 12 hrs. </span>
                        </small>
                        <small class="form-text text-muted" v-if="show_24_hr_warning">
                              <span  class="text-danger">Warning this shift is at or exceeds 24 hrs. </span>
                          </small>
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group label="Checked Out Date &amp; Time" label-for="checked_out_time">
                        <b-row>
                            <b-col cols="7">
                                <date-picker v-model="edit.checked_out_date" placeholder="Date (MM/DD/YYYY)"></date-picker>
                            </b-col>
                            <b-col cols="5">
                                <time-picker v-model="edit.checked_out_time" placeholder="Time (Ex. 12:00 PM)"></time-picker>
                            </b-col>
                        </b-row>
                        <input-help :form="form" field="checked_out_time" text=""></input-help>
                        <small class="form-text text-muted" v-if="show_12_hr_warning">
                          <span  class="text-warning">Warning this shift is at or exceeds 12 hrs. </span>
                        </small>
                        <small class="form-text text-muted" v-if="show_24_hr_warning">
                              <span  class="text-danger">Warning this shift is at or exceeds 24 hrs. </span>
                        </small>
                    </b-form-group>
                </b-col>
            </b-row> -->
            <!-- <b-row class="with-padding-bottom" v-show="disputeMode">
                <b-col sm="4">
                    <b-form-group label="Provider Rate" label-for="caregiver_rate">
                        <b-form-input
                            id="caregiver_rate"
                            name="caregiver_rate"
                            type="number"
                            step="any"
                            v-model="form.caregiver_rate"
                        >
                        </b-form-input>
                        <input-help :form="form" field="caregiver_rate" text=""></input-help>
                    </b-form-group>
                </b-col>
            </b-row> -->

            <b-row class="with-padding-bottom" v-if="shift.signature">
                <b-col>
                    <strong>Policy Holder Signature</strong>
                    <div v-html="shift.signature.content" class="signature"></div>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col sm="6 py-2">
                    <strong>Was this Visit Electronically Verified?</strong><br />
                    <span v-if="shift.verified">Yes</span>
                    <span v-else>No</span>
                </b-col>
            </b-row>

            <b-row class="with-padding-bottom" v-if="!disputeMode">
                <b-col sm="6 py-2">
                    <strong>Did the client fall?</strong><br />
                    <span v-if="shift.client_fall">Yes</span>
                    <span v-else>No</span>
                </b-col>
                
                <b-col sm="6 py-2" v-if="hospital_stays_enabled">
                    <strong>Has the client had any hospital stays since your last visit?</strong><br />
                    <span v-if="shift.hospital_stay">Yes</span>
                    <span v-else>No</span>
                </b-col>

                <b-col sm="6 py-2" v-if="hospital_stays_enabled && hospital_stays_enhanced_flow && shift.hospital_stay">
                    <strong>Is the client still currently in the hospital?</strong><br />
                    <span v-if="shift.still_in_hospital">Yes</span>
                    <span v-else>No</span>
                </b-col>

                <b-col sm="6 py-2" v-if="hospital_stays_enabled && hospital_stays_enhanced_flow && shift.hospital_stay">
                    <strong>Hospital stay dates</strong><br />
                    <span>
                        {{convertDateYmdToMdy(shift.hospital_stay_from_date)}}
                        &nbsp; to &nbsp;
                        <span v-if="shift.still_in_hospital">Currently in the hospital</span>
                        <span v-else>{{convertDateYmdToMdy(shift.hospital_stay_to_date)}}</span>
                    </span>
                </b-col>

                <b-col sm="6 py-2" v-if="shiftMod">
                        <strong>What are the reasons for modification?</strong><br />
                        <span>{{ shift.modification_reasons.join(", ") }}</span>
                    </b-col>

                <b-col sm="6 py-2" v-if="shift.manual_addition_reason">
                    <strong>What is the reason for the manual addition?</strong><br />
                    <span>{{ shift.manual_addition_reason }}</span>
                </b-col>

                <b-col sm="6 py-2" v-if="shift.dispute">
                    <strong>Dispute Reason</strong><br />
                    <span>{{ shift.dispute.reason ? shift.dispute.reason.reason : '' }}</span>
                </b-col>

                <b-col sm="6 py-2" v-if="shift.dispute">
                    <strong>Instructions to Claimant</strong><br />
                    <span>{{ shift.dispute.notes }}</span>
                </b-col>

                <b-col sm="6 py-2">
                    <strong>Client's Condition</strong><br />
                    <span v-if="shift.client_condition > 0">Improved</span>
                    <span v-else-if="shift.client_condition < 0">Declined</span>
                    <span v-else>No Change</span>
                </b-col>
            </b-row>

            <!-- <b-row class="with-padding-bottom" v-if="disputeMode">
                <b-col lg="6">
                    <b-form-group label="Did the client fall today?" label-class="h5">
                        <b-form-radio-group id="client_fall" v-model="form.client_fall" name="client_fall">
                            <b-form-radio value="1">Yes</b-form-radio>
                            <b-form-radio value="0">No</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col lg="6">
                    <b-form-group label="Was there a change in the client's condition today?" label-class="h5">
                        <b-form-radio-group id="client_condition" v-model="form.client_condition" name="client_condition">
                            <b-form-radio value="1">Improved</b-form-radio>
                            <b-form-radio value="-1">Declined</b-form-radio>
                            <b-form-radio value="0">No Change</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row> -->
            
          <b-row lg="12" class="mt-2" v-if="modification_reasons">
              <b-col lg="6">
                <b-form-group label="What is the Reason for Modification?" label-class="h5">
                  <p style="font-size: .9rem">Select all that apply.</p>

                  <b-form-checkbox-group
                      id="modification_reason"
                      name="modification_reason"
                      v-model="form.modification_reason"
                      :options="modification_reasons_options"
                      buttons
                  >
                  </b-form-checkbox-group>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- <shift-hospital-stay-input-x
                    v-if="disputeMode && hospital_stays_enabled"
                /> -->
            <strong>Activities Performed</strong>

            <b-row class="justify-content-md-center" v-for="activity in activities" :key="activity.id"  style="justify-content: flex-start !important;">
                <div class="col-lg-2 col-sm-6 col-xs-6">{{ activity.name }}</div>
                <div class="col-lg-3 col-sm-6 col-xs-6" v-if="disputeMode">
                    <b-form-select name="test" v-model="form.activities[activity.id]">
                        <option value="">---</option>

                        <option v-for="option in activity.responses" :key="option.id" :value="option.name" v-text="option.name" />
                    </b-form-select>
                </div>
                <div class="col-lg-3 col-sm-6 col-xs-6" v-else>
                    {{ form.activities[activity.id] || '---' }}
                </div>
            </b-row>

            <b-row>
                <b-col v-show="!disputeMode">
                    <div class="pull-right" v-if="shift.status != 'CLOCKED_IN'">
                        <!-- <b-btn @click="disputeMode = true" variant="danger">Modify</b-btn> -->
                        <b-btn v-if="!caregiverMode" :href="'/client/shifts/' +this.shift.id + '?dispute=1'" variant="danger" target="_blank">Modify</b-btn>

                        <b-btn v-if="caregiverMode" :href="'/caregiver/shifts/edit/' + this.shift.id" variant="danger" target="_blank">Modify</b-btn>
                    </div>
                </b-col>
                <!-- <b-col v-show="disputeMode">
                    <div class="pull-right">
                        <b-btn @click="saveDispute()" variant="success" :disabled="savingDispute">Save</b-btn>
                        <b-btn @click="cancelDispute()" variant="secondary" :disabled="savingDispute">Cancel</b-btn>
                    </div>
                </b-col> -->
            </b-row>
        </b-card>
    </div>
</template>

<script>
    import FormatsDates from "../../mixins/FormatsDates";
    import FormatsNumbers from "../../mixins/FormatsNumbers";
    import moment from "moment";
    import {forEach} from "lodash";
    import { mapState  } from 'vuex';
    import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex'

    export default {
        name: "ClientShift",

        mixins: [FormatsDates, FormatsNumbers],

        props: ['client', 'shift', 'dispute', 'activities', 'over_24_hours', 'adls_set', 'modification_reasons', 'active_modification_reasons', 'caregiverMode'],

        data() {
            return {
                hospital_stays_enabled: false,
                hospital_stays_enhanced_flow: false,
                disputeMode: !!this.dispute,
                savingDispute: false,
                form: new Form({}),
                duration: this.shift.duration,
                edit: {
                    checked_in_date: moment.utc(this.shift.checked_in_time).local().format('MM/DD/YYYY'),
                    checked_in_time: moment.utc(this.shift.checked_in_time).local().format('HH:mm'),
                    checked_out_date: this.shift.checked_out_time ? moment.utc(this.shift.checked_out_time).local().format('MM/DD/YYYY') : '',
                    checked_out_time: this.shift.checked_out_time ? moment.utc(this.shift.checked_out_time).local().format('HH:mm') : '',
                },
              show_12_hr_warning: false,
              show_24_hr_warning: false,
              modification_reasons_options: [],
              modification_reasons_prior_options: [],
            }
        },

        created() {
            this.makeForm();
        },

        computed: {
          ...mapState({
                count: state => state.hospital.count,
                hospital: state => state.hospital.hospitalStay,
            }),
            ...mapGetters('hospital',[
                'stayIsValid', // add the names of the getters you want to import
                'fromConditionOne',
                'fromConditionTwo',
                'toConditionOne',
                'toConditionTwo',
                'fromIsValid',
                'toIsValid',
	        ]),
          shiftMod(){
            console.debug("this.shift", this.shift)
            if (this.shift.modification_reasons) {
              return (this.shift.modification_reasons.length > 0) ? this.shift.modification_reasons : false;
            }

            return false;
          },
          hours(){
            let clockin = this.getClockedInMoment();
            let clockout = this.getClockedOutMoment();
            return   clockout.diff(clockin, 'hours',true);
          },
          hoursAreNegative() {
            let sign = Math.sign(this.hours);
            return sign === -1;
          },
          shiftIsOverTwelveHours() {
            let clockin = this.getClockedInMoment();
            let clockout = this.getClockedOutMoment();
            let diffInMinutes = clockout.diff(clockin, 'minutes');
            return diffInMinutes >= 720;
          },
          isOverTwentyFourHours(){
            return this.hours > 24;
          },

        },

        methods: {
          ...mapActions('hospital', [
              'getShifts','updateMax' ,'setHospitalStayVariable'
             ]),
            // updateHospitalStayFields(emitted) {
            //     this.form.hospital_stay = emitted.hospitalStay;
            //     this.form.still_in_hospital = emitted.stillInHospital;
            //     this.form.hospital_stay_from_date = emitted.fromDate;
            //     this.form.hospital_stay_to_date = emitted.toDate;
            // },
            updateHospitalStayFields(hospital) {
                this.form.hospital_stay             = hospital.hospital_stay;
                this.form.still_in_hospital         = hospital.still_in_hospital;
                this.form.hospital_stay_from_date   = hospital.from_date;
                this.form.hospital_stay_to_date     = hospital.to_date;
            },
            makeForm() {
                this.form = new Form({
                    checked_in_time: this.shift.checked_in_time,
                    checked_out_time: this.shift.checked_out_time,
                    activities: this.getActivities(),
                    caregiver_rate: ('caregiver_rate' in this.shift) ? parseFloat(this.shift.caregiver_rate).toFixed(2) : '',
                    client_fall: this.shift.client_fall,
                    client_condition: this.shift.client_condition,
                    hospital_stay: this.shift.hospital_stay,
                    still_in_hospital: this.hospital.still_in_hospital,
                    hospital_stay_from_date: this.hospital.hospital_stay_from_date,
                    hospital_stay_to_date: this.hospital.hospital_stay_to_date,
                    total_hours: this.shift.total_hours,
                    modification_reason : this.shift.modification_reasons,
                });

                this.hospital_stays_enabled = this.shift.client.carrier.hospital_stays_enabled;
                this.hospital_stays_enhanced_flow = this.shift.client.carrier.hospital_stays_enhanced_flow;
            },

            getActivities() {
                let activities = [];
                let shiftActivities = this.shift.activities || [];
                let shiftActivity;
                for(let activity of this.activities) {
                    shiftActivity = shiftActivities.find(item => item.id === activity.id);
                    let value = (shiftActivity) ? shiftActivity.value : '';
                    activities[activity.id] = value;
                }
                return activities;
            },

            cancelDispute() {
                this.disputeMode = false;
                this.makeForm();
            },

            async saveDispute() {

                this.form.total_hours = this.hours;
                await this.runValidators();

                if (this.form.hasError() || !this.stayIsValid) {
                    alerts.addMessage('error', 'Please fix form errors.');
                    return;
                  }
                try {
                  this.savingDispute = true;
                    const response = await this.form.post('/client/shifts/' + this.shift.id + '/dispute');
                    // this.disputeMode = false;
                    this.duration = response.data.data.duration;
                }
                catch (err) {
                    this.savingDispute = false;
                }
            },
          validateTimeDifference(field) {
            this.$nextTick(function() {
              let clockin = this.getClockedInMoment();
              let clockout = this.getClockedOutMoment();
              if (clockin.isValid() && clockout.isValid()) {
                let rules = ['shiftIsOverTwelveHours', 'isFuture', 'overTwentyFourHours',  'checkOutIsBeforeCheckIn']
                forEach(rules, (rule) => {
                  this.evaluateErrors(field, rule);
                });
              }
            });
          },
          evaluateErrors(field ,rule){
            switch (rule) {
              case 'shiftIsOverTwelveHours':
                if(this.shiftIsOverTwelveHours){
                  if (field === 'checked_in_time' || field === 'checked_in_date') {
                    this.show_12_hr_warning = true;
                  } else {
                    this.show_12_hr_warning = true;
                  }
                }else{
                  this.show_12_hr_warning = false;
                }
                break;
              case 'isFuture':
                let isFuture = this.isFuture();
                if(isFuture){
                  if (field === 'checked_in_time' || field === 'checked_in_date') {
                    this.form.addError('checked_in_time', 'The check-in date and time cannot be in the future.');
                    this.form.addError('checked_in_date', 'The check-in date and time cannot be in the future.');
                  } else {
                    this.form.addError('checked_out_time', 'The check-out date and time cannot be in the future.');
                    this.form.addError('checked_out_date', 'The check-out date and time cannot be in the future.');
                  }
                }else{
                  let fieldError = this.form.getError();
                  if(fieldError === 'The check-in date and time cannot be in the future.'
                      || fieldError === 'The check-out date and time cannot be in the future.') {
                    this.form.clearError();
                  }
                }
                break;
                case 'overTwentyFourHours':
                            //Temp fix for the 24 hr issue bug 438057
                          if(this.isOverTwentyFourHours) {
                            if (field === 'checked_in_time' || field === 'checked_in_date') {
                            // do not show the 24 hr warning if the shift is over 24 hrs per bug 438057 temp fix
                            //    this.show_24_hr_warning = true;
                            //   this.form.addError('checked_in_time', 'The check-in date and time cannot be 24 hrs or more than the check-out date and time.');
                            //   this.form.addError('checked_in_date', 'The check-in date and time cannot be 24 hrs or more than the check-out date and time.');
                            } else {
                            // do not show the 24 hr warning if the shift is over 24 hrs per bug 438057 temp fix    this.show_24_hr_warning = true;
                            //   this.form.addError('checked_out_time', 'The check-out date and time cannot be 24 hrs or more than the check-in date and time.');
                            //   this.form.addError('checked_out_date', 'The check-out date and time cannot be 24 hrs or more than the check-in date and time.');
                            }
                          }else{
                            // do not show the 24 hr warning if the shift is over 24 hrs per bug 438057 temp fix this.show_24_hr_warning = false;
                            //  let fieldError = this.form.getError();
                            //  if(fieldError === 'The check-in date and time cannot be 24 hrs or more than the check-out date and time.'
                            //      || fieldError === 'The check-out date and time cannot be 24 hrs or more than the check-in date and time.')
                            //  {
                            //    this.form.clearError();
                            //  }
                          }
              break;
              case 'checkOutIsBeforeCheckIn':
                if(this.hoursAreNegative) {
                  if (field === 'checked_in_time' || field === 'checked_in_date') {
                    this.form.addError('checked_in_time', 'The check-in date and time must be before the check-out date and time.');
                    this.form.addError('checked_in_date', 'The check-in date and time must be before the check-out date and time.');
                  } else {
                    this.form.addError('checked_out_time', 'The check-out date and time must be after the check-in date and time.');
                    this.form.addError('checked_out_date', 'The check-out date and time must be after the check-in date and time.');
                  }
                }else{
                  let fieldError = this.form.getError();
                  if(fieldError === 'The check-out date and time must be after the check-in date and time.'
                      || fieldError === 'The check-in date and time must be before the check-out date and time.')
                  {
                    this.form.clearError();
                  }
                }
                break;
              default:
                return false;
            }

          },
          async runValidators(){
            this.form.clearError();
            this.validateTimeDifference('checked_in_date');
            this.validateTimeDifference('checked_in_time');
            this.validateTimeDifference('checked_out_date');
            this.validateTimeDifference('checked_out_time');
            if (this.form.hasError()) {
              alerts.addMessage('error', 'Please fix form errors.');
              return false;
            }else{
              return true;
            }
          },
          isFuture(field){
            var clock
            if(field === 'checked_in_date' || field === 'checked_in_time'){
              clock = this.getClockedInMoment();
            }else{
              clock = this.getClockedOutMoment()
            }
            let current = this.currentTime();
            return  moment(clock).isAfter(current);

          },
          getClockedInMoment() {
              return moment(this.edit.checked_in_date + ' ' + this.edit.checked_in_time, 'MM/DD/YYYY HH:mm');
            },
          getClockedOutMoment() {
            return moment(this.edit.checked_out_date + ' ' + this.edit.checked_out_time, 'MM/DD/YYYY HH:mm');
          },
          currentTime(){
            let now = moment();
            return moment(now, 'MM/DD/YYYY HH:mm');
          },
        },
        watch: {
            'edit': {
                deep: true,
                handler: function(edit) {
                    this.form.checked_in_time = moment(edit.checked_in_date + ' ' + edit.checked_in_time, 'MM/DD/YYYY HH:mm').utc().format('YYYY-MM-DD HH:mm:ss');
                    this.validateTimeDifference('checked_in_time');
                    this.validateTimeDifference('checked_in_date')
                    this.form.checked_out_time = moment(edit.checked_out_date + ' ' + edit.checked_out_time, 'MM/DD/YYYY HH:mm').utc().format('YYYY-MM-DD HH:mm:ss');
                    this.validateTimeDifference('checked_out_time');
                    this.validateTimeDifference('checked_out_date')
                    this.form.checked_in_date = moment(edit.checked_in_date + ' ' + edit.checked_in_time, 'MM/DD/YYYY HH:mm').utc().format('YYYY-MM-DD HH:mm:ss');
                    this.validateTimeDifference('checked_in_time');
                    this.validateTimeDifference('checked_in_date')
                    this.form.checked_out_date = moment(edit.checked_out_date + ' ' + edit.checked_out_time, 'MM/DD/YYYY HH:mm').utc().format('YYYY-MM-DD HH:mm:ss');
                    this.validateTimeDifference('checked_out_time');
                    this.validateTimeDifference('checked_out_date')

                }
            },
            'form.checked_in_time': function() {
              this.validateTimeDifference('checked_in_time')
            },
            'form.checked_in_date': function() {
              this.validateTimeDifference('checked_in_date')
            },
            'form.checked_out_time': function() {
              this.validateTimeDifference('checked_out_time')
            },
            'form.checked_out_date': function() {
              this.validateTimeDifference('checked_out_date')
            },
            maxDate(val, old ){
              
              this.updateMax(val);
          },
          'hospital': {
              handler: function (val, oldVal) {
                  this.updateHospitalStayFields(val);
              },
              deep: true
          },
        },
        mounted() {
          if( this.shift.id ){
            let payload = {id:this.shift.id,client:true};
            this.getShifts(payload);
          }

          if (this.shift.manual_addition_reason) {
              this.form.manual_addition_reason = this.shift.manual_addition_reason
          }

          // Populate the Modification Reasons
          if(this.modification_reasons) {
            for (let reason of this.modification_reasons) {
              let item = {text: reason.name, value: reason.id}
              this.modification_reasons_options.push(item)
            }

            // Mark Selected Modification Reasons (if set)
            for (let selected of this.active_modification_reasons) {
              this.form.modification_reason.push(selected)
            }
          }
        }
    }
</script>

<style scoped>

</style>
